import type { AccountTagApiResponse } from '@/components/account/types'
import type {
	MappedTag, TableTag, TagApiResponse
} from '@/types/tags'

const mapTags = (response: TagApiResponse[] | AccountTagApiResponse[]): MappedTag[] => {
	return response?.map(tag => {
		return {
			id: tag?.tagId?.toString() || '',
			name: tag?.tagName || ''
		}
	}).sort((a, b) => {
		return a.name.localeCompare(b.name)
	})
}

const mapTableTags = (response: TagApiResponse[]): TableTag[] => {
	return response?.map(tag => {
		return {
			id: tag?.tagId?.toString() || '',
			name: tag?.tagName || '',
			lastModified: tag?.lastModified,
			createdTime: tag?.createdTime,
			accountIds: tag?.accountIds,
			tagType: tag?.tagType
		}
	}).sort((a, b) => {
		return a.name.localeCompare(b.name)
	})
}

export { mapTableTags, mapTags }
